/**
 * @deprecated Do not use legacy components anymore.
 */
export var AvatarSize;
(function (AvatarSize) {
    AvatarSize[AvatarSize["Small"] = 16] = "Small";
    AvatarSize[AvatarSize["Medium"] = 30] = "Medium";
    AvatarSize[AvatarSize["Large"] = 50] = "Large";
})(AvatarSize || (AvatarSize = {}));
//# sourceMappingURL=AvatarProps.js.map